module.exports = __webpack_public_path__ + "static/media/heroku-icon.771c7f65.png";